// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1908":"e39f17f19a280c34","9228":"396f15bfefada1f6"}[chunkId] + ".css";
};